import config from "infra/config";

const URL = {
  USUARIO: {
    PERFIL: "/user/perfil",
    PHOTO: "/user/perfil-social/avatar/upload",
    LISTA_DE_USUARIOS: "/User",
    NOVO_USUARIO: "/User",
    ATUALIZAR_USUARIO: (usuarioId: string) => `/User/${usuarioId}`,
    ATUALIAR_FOTO_DO_USUARIO: (usuarioId: string) =>
      `/User/${usuarioId}/perfil-social/avatar/upload`,
  },
  TERMO_USO: {
    ACEITAR: "/user/termos-uso/aceitar",
  },
  SHARE: {
    CRIAR: `/web/share`,
    OBTER: (id: string) => `/web/share/${id}`,
  },
  UNIDADES: {
    SETORES: (fazendaId: string, safraId: string) =>
      `/unidades/${fazendaId}/safras/${safraId}/setores`,
    REGIONAL: "unidades/regional",
  },
  MAPAS: {
    GERAL: (unidadeId: string, safraId: string) =>
      `/web/unidades/${unidadeId}/safras/${safraId}/talhoes`,
    OCUPACOES: (unidadeId: string, safraId: string) =>
      `web/Unidades/${unidadeId}/safras/${safraId}/ocupacoes`,
    DISTRIBUICAO_VARIETAL: (unidadeId: string, safraId: string) =>
      `/web/unidades/${unidadeId}/mapa/distribuicao-varietal?safraId=${safraId}`,
    UNIDADES: "/unidades",
    SAFRAS: "/safras",
    TEXTURAS_SOLO: "/texturassolo",
    MAPA_TEXTURAS_SOLO: (unidadeId: string, texturas: number[]) => {
      let url = `/web/unidades/${unidadeId}/mapa/textura-solo?`;
      texturas.forEach((textura) => {
        url = url + `textura=${textura}&`;
      });
      return url;
    },
    MAPA_OPERACOES_EXECUTADAS: (unidadeId: string, safraId: string) =>
      `/web/unidades/${unidadeId}/mapa/operacao?safraId=${safraId}`,
    OPERACOES_EXECUTADAS: (unidadeId: string, safraId: string) =>
      `web/Unidades/${unidadeId}/safras/${safraId}/operacoes`,
    MAPA_NUMERO_DE_APLICACOES: (unidadeId: string, safraId: string) =>
      `/web/unidades/${unidadeId}/mapa/numero-aplicacoes?safraId=${safraId}`,
    NUMERO_DE_APLICACOES: (unidadeId: string, safraId: string) =>
      `/web/Unidades/${unidadeId}/safras/${safraId}/numero-aplicacoes`,
    MAPA_PRODUTIVIDADE: (unidadeId: string, safraId: string) =>
      `/web/unidades/${unidadeId}/mapa/produtividade?safraId=${safraId}`,
    MAPA_CONCENTRACAO_COLHEITA: (unidadeId: string, safraId: string) =>
      `/web/unidades/${unidadeId}/mapa/concentracao-colheita?safraId=${safraId}`,
    CONCENTRACAO_COLHEITA: (unidadeId: string, safraId: string) =>
      `/web/Unidades/${unidadeId}/safras/${safraId}/concentracao-colheita`,
    PRODUTIVIDADE: (unidadeId: string, safraId: string) =>
      `/web/unidades/${unidadeId}/safras/${safraId}/produtividade`,
    MAPA_IDADE_DO_TALHAO: (unidadeId: string, safraId: string) =>
      `/web/unidades/${unidadeId}/mapa/idade-talhao?safraId=${safraId}`,
    IDADE_DO_TALHAO: (unidadeId: string, safraId: string) =>
      `/web/unidades/${unidadeId}/safras/${safraId}/idade-talhao`,
    MAPA_DE_CHUVA_FILTRO_RAPIDO: () =>
      `/web/unidades/mapa/pluviometrico/filtro-rapido`,
    MAPA_DE_CHUVA_FILTRO_INDICES: (periodo: number, unidadeId: string) =>
      `/web/unidades/${unidadeId}/mapa/pluviometrico/${periodo}/filtro-indices`,
    MAPA_DE_CHUVA_GEOJSON: (unidadeId: string) =>
      `/web/unidades/${unidadeId}/mapa/pluviometrico`,
    ORDENS_DE_SERVICOS_ABERTAS: (unidadeId: string) =>
      `/web/unidades/${unidadeId}/ordens-de-servicos-abertas`,
    MAPA_ORDENS_DE_SERVICOS_ABERTAS: (unidadeId: string) =>
      `/web/unidades/${unidadeId}/mapa/ordens-de-servicos-abertas`,
    DISTRIBUICAO_DE_EQUIPES: (unidadeId: string) =>
      `/web/unidades/${unidadeId}/distribuicao-equipe`,
    MAPA_DISTRIBUICAO_DE_EQUIPES: (unidadeId: string) =>
      `/web/unidades/${unidadeId}/mapa/distribuicao-equipe`,
    TABELA_ORDENS_DE_SERVICOS_ABERTAS_POR_EQUIPE: (unidadeId: string) =>
      `/Unidades/${unidadeId}/ordens-abertas`,
  },
  TALHOES: {
    DETALHE_TALHAO: (talhaoId: string) => `/talhoes/${talhaoId}/detalhes`,
    ORDENS_SERVICO: (talhaoId: string) => `/talhoes/${talhaoId}/ordens-servico`,
    ORDENS_SERVICO_TELEMETRIA: (talhaoId: string, ordemServicoId: string) =>
      `/talhoes/${talhaoId}/telemetria?ordemServicoId=${ordemServicoId}`,
    OPERACOES_REALIZADAS: (talhaoId: string) =>
      `/talhoes/${talhaoId}/operacoes`,
    APLICACOES: (talhaoId: string) => `/talhoes/${talhaoId}/aplicacoes`,
    APLICACOES_GRAFICO: (talhaoId: string) =>
      `/Talhoes/${talhaoId}/custo-aplicacoes`,
    TALHAO_RESUMIDO: (talhaoId: string) => `/talhoes/${talhaoId}`,
    PRODUTIVIDADE: (talhaoId: string, page: number = 1) =>
      `/web/talhoes/${talhaoId}/historico-produtividade?Size=100`,
    PRODUTIVIDADE_WITH_FILTER: (
      talhaoId: string,
      filter: number,
      page: number = 1,
    ) =>
      `/web/talhoes/${talhaoId}/historico-produtividade?Page=${page}&Size=10&Ocupacao=${filter}`,
  },
  EDITAR_TALHOES: {
    OCUPACAO_E_TECNOLOGIAS: (unidadeId: string, safraId: string) =>
      `/gerencia-de-talhoes/unidades/${unidadeId}/safras/${safraId}/filtro`,
    LISTA_E_GEOJSON: (unidadeId: string, safraId: string) =>
      `/gerencia-de-talhoes/unidades/${unidadeId}/safras/${safraId}/talhoes`,
    SALVAR_TALHOES_EDITADOS: (talhaoId: string) =>
      `/gerencia-de-talhoes/${talhaoId}`,
  },
  IMPORTAR_TALHOES: {
    SAFRA_PERIODO: (safraId: string, unidadeId: string) =>
      `/safras/${safraId}/unidade/${unidadeId}/safra-periodos`,
    SAFRA_PERIODO_OCUPACAO: (safraId: string, ocupacaoId: string) =>
      `/safras/${safraId}/ocupacao/${ocupacaoId}/safra-periodos`,
    KML_VALIDATE: (
      unidadeId: string,
      safraId: string,
      safraPeriodoId: string,
    ) =>
      `/kml/unidades/${unidadeId}/safras/${safraId}/safra-periodo/${safraPeriodoId}/kml/validate`,
    KML_UPDATE: () => "/kml",
  },
  INSUMOS_TALHOES: {
    INSUMOS_TALHAO: (talhaoId: string) =>
      `/talhoes/${talhaoId}/insumos-grupos-disponiveis`,
  },
  GRAFICO: {
    CONCENTRACAO_DE_COLHEITA: () => "/concentracao-colheita/semana",
    INDICES_PLUVIOMETRICOS: (talhaoId: string, filterBy: number) =>
      `/talhoes/${talhaoId}/grafico-pluviometrico?by=${filterBy}`,
  },
  PERFIS: {
    PERFIS_LISTA: "/Perfis",
  },
  PERMISSOES: {
    LISTA: "/Permissoes",
  },
  AGRODRIVE: {
    ARQUIVOS: () => `${config.urlAgrodriveApi}/v1/arquivo`,
    ARQUIVOS_LIST: (
      pagina: number,
      tamanhoPagina: number,
      texto?: string,
      tags?: string,
    ) =>
      `${config.urlAgrodriveApi}/v1/arquivo?texto=${texto}&tags=${tags}&pagina=${pagina}&tamanhoPagina=${tamanhoPagina}`,
    ARQUIVOS_FIND: () => `${config.urlAgrodriveApi}/v1/arquivo`,
    ARQUIVOS_UPDATE: (id: string) => `${config.urlAgrodriveApi}/v1/arquivo`,
    ARQUIVOS_DELETE: (ids: string[]) => `${config.urlAgrodriveApi}/v1/arquivo`,
    ARQUIVOS_DOWNLOAD: (ids: string[]) => {
      const idsQuery = ids.map((id) => `ids=${id}`).join("&");
      return `${config.urlAgrodriveApi}/v1/Download?${idsQuery}`;
    },
    ARQUIVOS_MOVE: (id: string, newFolderId: string) =>
      `${config.urlAgrodriveApi}/v1/arquivo/${id}/move/${newFolderId ?? ""}`,
    DIRETORIO: () => `${config.urlAgrodriveApi}/v1/diretorio`,
    DIRETORIO_LIST: (
      diretorio: string,
      pagina: number,
      tamanhoPagina: number,
      orderBy: string,
    ) =>
      `${config.urlAgrodriveApi}/v1/diretorio?diretorio=${diretorio}&pagina=${pagina}&tamanhoPagina=${tamanhoPagina}&orderBy=${orderBy}`,
    TALHAO: () => `${config.urlAgrodriveApi}/v1/tag/custon`,
    CULTURA_LIST: (unidadeId: string, safraId: string, culturaId: string) =>
      `${config.urlAgrodriveApi}/v1/cultura?unidade=${unidadeId}&safra=${safraId}&culturaId=${culturaId}`,
    SETORES_LIST: () => `${config.urlAgrodriveApi}/...}`,

    UNIDADE: () => `${config.urlAgrodriveApi}/v1/unidade`,
    SAFRA: (fazendaIds: string[]) =>
      `${config.urlAgrodriveApi}/v1/safra?${fazendaIds.map(
        (fazendaID: string) => {
          return `fazendaIds=${fazendaID}&`;
        },
      )}`,
    CULTURA: () => `${config.urlAgrodriveApi}/...`,
    SETORES: (fazendaIds: string[], safraIds: string[]) =>
      `${config.urlAgrodriveApi}/v1/setor?${fazendaIds.map(
        (fazendaID: string) => {
          return `fazendaIds=${fazendaID}&`;
        },
      )}${safraIds.map((safraID: string) => {
        return `safraIds=${safraID}&`;
      })}`,
    TAGS: () => `${config.urlAgrodriveApi}/v1/tag/custon`,
  },

  JUSTIFICATIVA: {
    ATRASOS: (
      idFazenda?: string,
      codigoOcupacao?: string,
      idSafra?: string,
      regional?: string,
      idPlanoOperacionalOperacaoTipoAtraso?: number,
      apenasAprovados?: boolean,
      apenasJustificados?: boolean,
      apenasAprovadosCiente?: boolean,
      apenasPendentesJustificativas?: boolean,
      page?: number,
      size?: number,
    ) =>
      `plano-operacional/atrasados?pagina=${page}&tamanhoPagina=${size}${regional ? `&regional=${regional}` : ""}${idFazenda ? `&idFazenda=${idFazenda}` : ""}${codigoOcupacao ? `&codigoOcupacao=${codigoOcupacao}` : ""}${idSafra ? `&idSafra=${idSafra}` : ""}${idPlanoOperacionalOperacaoTipoAtraso ? `&idPlanoOperacionalOperacaoTipoAtraso=${idPlanoOperacionalOperacaoTipoAtraso}` : ""}${apenasAprovados !== undefined ? `&apenasAprovados=${apenasAprovados}` : ""}${apenasJustificados !== undefined ? `&apenasJustificados=${apenasJustificados}` : ""}${apenasAprovadosCiente !== undefined ? `&apenasAprovadosCiente=${apenasAprovadosCiente}` : ""}${apenasPendentesJustificativas !== undefined ? `&apenasPendentesJustificativas=${apenasPendentesJustificativas}` : ""}`,
    ATRASOS_TOTAL: (
      idFazenda?: string,
      codigoOcupacao?: string,
      idSafra?: string,
      regional?: string,
      idPlanoOperacionalOperacaoTipoAtraso?: number,
      apenasAprovados?: boolean,
      apenasJustificados?: boolean,
      apenasAprovadosCiente?: boolean,
      apenasPendentesJustificativas?: boolean,
    ) =>
      `plano-operacional/atrasados/total?${regional ? `&regional=${regional}` : ""}${idFazenda ? `&idFazenda=${idFazenda}` : ""}${codigoOcupacao ? `&codigoOcupacao=${codigoOcupacao}` : ""}${idSafra ? `&idSafra=${idSafra}` : ""}${idPlanoOperacionalOperacaoTipoAtraso ? `&idPlanoOperacionalOperacaoTipoAtraso=${idPlanoOperacionalOperacaoTipoAtraso}` : ""}${apenasAprovados !== undefined ? `&apenasAprovados=${apenasAprovados}` : ""}${apenasJustificados !== undefined ? `&apenasJustificados=${apenasJustificados}` : ""}${apenasAprovadosCiente !== undefined ? `&apenasAprovadosCiente=${apenasAprovadosCiente}` : ""}${apenasPendentesJustificativas !== undefined ? `&apenasPendentesJustificativas=${apenasPendentesJustificativas}` : ""}`,
    SALVAR: (idPlanoOperacionalOperacao: number) =>
      `plano-operacional/${idPlanoOperacionalOperacao}/justificativas`,
    APROVAR: (idPlanoOperacionalOperacao: string, idJustificativa: string) =>
      `plano-operacional/${idPlanoOperacionalOperacao}/justificativas/${idJustificativa}/aprovar`,
    JUSTIFICATIVA: (
      idPlanoOperacionalOperacao: number,
      idJustificativa: number,
    ) =>
      `plano-operacional/${idPlanoOperacionalOperacao}/justificativas/${idJustificativa}`,
    TIPOS_ATRASO: "plano-operacional/tipos-atraso",
    CIENTE: "plano-operacional/justificativas/ciente",
  },
  PRECIPITACAO: {
    OBTER: (t: string) => `/precipitacao?t=${t}`,
  },
  PLANO_OPERACIONAL: {
    OBTER: "web/plano-operacional",
    OBTER_VALIDACAO_CODIGO: "web/plano-operacional/validar-codigo",
    OBTER_VALIDACAO_DESCRICAO: "web/plano-operacional/validar-descricao",
    OBTER_IMPORTACAO: "web/importacao/plano-operacional",
    OBTER_COM_FILTRO: (idUnidade: string, idSafra: string) =>
      `web/unidades/${idUnidade}/safras/${idSafra}/plano-operacional`,
    OBTER_BY_ID: (planoOperacionalId: string) =>
      `web/plano-operacional/${planoOperacionalId}`,
    OBTER_DROPDOWN_OPERACAO: "web/operacao/dropdown",
    OBTER_DROPDOWN_COMPONENTE: "web/componente/dropdown",
    OBTER_DROPDOWN_PERIODO_FILTRO: (safraId: string, ocupacaoId: string) =>
      `safras/${safraId}/ocupacao/${ocupacaoId}/safra-periodos`,
    OBTER_DROPDOWN_PERIODO: (safraId: string, unidadeId: string) =>
      `safras/${safraId}/unidade/${unidadeId}/safra-periodos`,
    OBTER_DROPDOWN_REFERENCIA: "web/plano-operacional-referencias/dropdown",
    OBTER_REFERENCIAS: "web/plano-operacional-referencias",
    OBTER_REFERENCIA_BY_ID: (id: string) =>
      `web/plano-operacional-referencias/${id}`,
    OBTER_DROPDOWN_ALVO: "web/alvo/dropdown",
    CRIAR_PLANEJAMENTO: "web/plano-operacional",
    CRIAR_PLANEJAMENTO_OPERACAO: (id: string) =>
      `web/plano-operacional/${id}/operacoes`,
    DELETAR_PLANEJAMENTO: (id: string) => `web/plano-operacional/${id}`,
    ATUALIZAR_PLANEJAMENTO: (id: string) => `web/plano-operacional/${id}`,
    DELETAR_PLANEJAMENTO_OPERACAO: (id: string) =>
      `web/plano-operacional/${id}/operacoes`,
    COPIAR_PLANEJAMENTO: (origemTalhaoId: string, destinoTalhaoId: string) =>
      `web/plano-operacional/${origemTalhaoId}/copiar/${destinoTalhaoId}`,
    PLANEJAMENTOS_POR_TALHAO: (talhaoId: string) =>
      `web/plano-operacional/por-talhao/${talhaoId}`,
    VINCULAR_TALHOES: "web/plano-operacional/vincular/talhoes",
    OBTER_CENARIOS_DROPDOWN_ID_EXTERNO: "web/cenario/dropdown/id-externo",
    OBTER_CLASSES_OPERACAO_DROPDOWN_ID_EXTERNO:
      "web/classes-operacao/dropdown/id-externo",
    OBTER_OPERACAO_DROPDOWN_ID_EXTERNO: "web/operacao/dropdown/id-externo",
    OBTER_EQUIPE_DROPDOWN_ID_EXTERNO: "web/equipe/dropdown/id-externo",
    OBTER_SISTEMA_APLICACAO_DROPDOWN_ID_EXTERNO:
      "web/sistema-aplicacao/dropdown/id-externo",
    OBTER_TIPO_BICO_DROPDOWN_ID_EXTERNO: "web/tipo-bico/dropdown/id-externo",
    OBTER_CENTRO_CUSTO_DROPDOWN_ID_EXTERNO:
      "web/centro-custo/dropdown/id-externo",
    OBTER_ALVO_DROPDOWN_ID_EXTERNO: "web/alvo/dropdown/id-externo",
    OBTER_COMPONENTE_DROPDOWN_ID_EXTERNO: "web/componente/dropdown/id-externo",
    OBTER_FLAGS_DADOS_TECNICOS: (idExternoOperacao?: string) =>
      `web/operacao/${idExternoOperacao}/flags-dados-tecnicos`,
    OBTER_GRUPO_PLANO_OPERACIONAL_DROPDOWN_ID_EXTERNO:
      "web/grupo-plano-operacional/dropdown/id-externo",
    OBTER_GRUPO_PLANO_OPERACIONAL_SUBGRUPO_DROPDOWN_ID_EXTERNO: (id: string) =>
      `web/grupo-plano-operacional/${id}/subgrupo/dropdown/id-externo`,
    OBTER_IMPORTACAO_PLANO_OPERACIONAL_ID_EXTERNO:
      "web/importacao/plano-operacional",
    OBTER_IMPORTACAO_PLANO_OPERACIONAL_OPERACAO_ID_EXTERNO: (id: string) =>
      `web/importacao/plano-operacional/${id}/operacao`,
    SAFRA_DROPDOWN_ID_EXTERNO: "web/safra/dropdown/id-externo",
    OCUPACAO_DROPDOWN_ID_EXTERNO: "web/ocupacao/dropdown/id-externo",
    UNIDADE_DROPDOWN_ID_EXTERNO: "web/unidade/dropdown/id-externo",
    OBTER_MAPA: (unidadeId: string) =>
      `/web/unidades/${unidadeId}/mapa/plano-operacional`,
    OBTER_MAPA_ORDEM_SERVICO: (unidadeId: string) =>
      `/web/unidades/${unidadeId}/mapa/ordem-servico`,
    ATUALIZAR_SAFRA: (id: string) =>
      `/web/plano-operacional/${id}/safra-periodos`,
    CANCELAR_VINCULO: "web/plano-operacional/excluir/talhoes",
    OBTER_LISTA_POR_TALHAO: (id: string) =>
      `web/plano-operacional/por-talhao/${id}`,
    OBTER_HISTORICO_TALHAO_ORDEM_SERVICO: (id: string) =>
      `web/ordem-servico/talhoes/${id}/historico`,
    OBTER_HISTORICO_TALHAO: (id: string) =>
      `web/plano-operacional/talhoes/${id}/historico`,
    ATUALIZAR_ORDEM_SERVICO_TALHOES: `web/ordem-servico/talhoes`,
    CRIAR_OPERACAO_AVULSA: `web/plano-operacional/vincular/operacao-avulsa`,
    OBTER_ORDEM_SERVICO_TALHAO: "web/ordem-servico/talhoes",
    OBTER_OPERACAO_TALHAO_JUSTIFICATIVA:
      "web/plano-operacional/talhoes/justificados",
    OBTER_OPERACAO_TALHAO_JUSTIFICATIVA_ATUALIZAR:
      "web/plano-operacional/talhoes/justificados/parecer",
  },
  AGENDA: {
    TRADICIONAL: "web/plano-operacional/agenda-tradicional",
    TALHAO: "web/plano-operacional/agenda-talhao",
    DETALHE: "web/plano-operacional/agenda-detalhe",
    EXPORTAR_PDF: "web/plano-operacional/agenda-detalhe/exportar/pdf",
    JANELA_EXECUCAO: "web/plano-operacional/agenda-janela-execucao",
    JANELA_EXECUCAO_DETALHE:
      "web/plano-operacional/agenda-janela-execucao/detalhe",
  },
  RELATORIO: {
    SETORES: (unidadeId: string, safraId: string) =>
      `unidades/${unidadeId}/safras/${safraId}/setores`,
    TALHOES: "web/talhoes/dropdown/cronograma-operacional",
    ANALITICO: "web/plano-operacional/agenda-campo-analitico",
    EXPORTAR_XLS: "web/plano-operacional/agenda-campo-analitico/exportar/xls",
    GRAFICO: "web/plano-operacional/cronograma-operacional",
    DETALHE_ADERENTE: (talhaoId: string, dias: number, tipo: number) =>
      `web/plano-operacional/talhoes/${talhaoId}/aderencia?ToleranciaEmDias=${dias}&Tipo=${tipo}`,
    EXPORTAR_DETALHE_ADERENTE: (talhaoId: string) =>
      `web/plano-operacional/talhoes/${talhaoId}/aderencia/exportar/xls`,
    DIARIO_OPERACOES: "web/plano-operacional/diario-operacoes-agricolas",
    DIARIO_OPERACOES_CURVA_S:
      "web/plano-operacional/diario-operacoes-agricolas/curva-s",
    DIARIO_OPERACOES_RITMO_DIARIO:
      "web/plano-operacional/diario-operacoes-agricolas/ritmo-diario",
  },
  CLIMATOLOGIA: {
    MEDIAS_CLIMATICAS: (safraId: string, unidadeId: string) =>
      `Climatologia/medias-climaticas/safra/${safraId}/unidade/${unidadeId}`,
  },
  CLASSES_OPERACAO: {
    OBTER: "web/classes-operacao",
    SALVAR: "web/classes-operacao",
    OPERACOES: "web/operacao",
    OBTER_POR_ID: (operacaoClasseId: string) =>
      `web/classes-operacao/${operacaoClasseId}`,
    ATUALIZAR: (operacaoClasseId: string) =>
      `web/classes-operacao/${operacaoClasseId}`,
    DELETAR: (operacaoClasseId: string) =>
      `web/classes-operacao/${operacaoClasseId}`,
  },
  OCUPACOES: {
    OBTER: "web/ocupacoes",
    ATUALIZAR: (ocupacaoId: string) => `web/ocupacoes/${ocupacaoId}`,
  },
  ORDEM_SERVICO: {
    OBTER: "web/ordem-servico",
    TALHOES: "web/ordem-servico/talhoes",
    OBTER_POR_ID: (ordemServicoId: string) =>
      `web/ordem-servico/${ordemServicoId}`,
    OBTER_APONTAMENTO: (ordemServicoId: string, talhaoIds: string[]) =>
      `web/ordem-servico/${ordemServicoId}/talhoes/apontamento?${talhaoIds.map((t) => `talhaoIds=${t}`).join("&")}`,
    TALHAO_HISTORICO: (talhaoId: string) =>
      `web/ordem-servico/talhoes/${talhaoId}/historico`,
    INSUMOS: (idExternoComponente: string, idExternoUnidade?: string) =>
      `web/insumo/unidade/${idExternoUnidade}/componente/${idExternoComponente}/dropdown/id-externo`,
    INSUMO_POR_ID_EXTERNO: (idExternoInsumo: string) =>
      `web/insumo/${idExternoInsumo}`,
    OBTER_LISTAS: (idUnidade: string, idSafra: string) =>
      `web/unidades/${idUnidade}/safras/${idSafra}/ordem-servico`,
    VINCULAR_TALHOES: "web/ordem-servico/vincular/talhoes",
    EXPORTAR_PDF: (ordemServicoId: string) =>
      `web/ordem-servico/${ordemServicoId}/exportar/pdf`,
    PREVISAO_ESTOQUE: "web/previsao-estoque",
  },
  RECURRING_JOB_GROUP: {
    OBTER: (page: number, size: number, name?: string, status?: boolean) => {
      const queryParams = new URLSearchParams();

      if (name !== undefined && name !== null && name !== "") {
        queryParams.append("nome", name);
      }

      if (
        status !== undefined &&
        status !== null &&
        typeof status === "boolean"
      ) {
        queryParams.append("ativo", status.toString());
      }
      return `web/recurring-job-groups?page=${page}&size=${size}&${queryParams.toString()}`;
    },
    OBTER_JOBS_BY_GROUP_ID: (groupId: string): string => {
      return `web/recurring-job-groups/${groupId}`;
    },
    OBTER_ALL_JOBS: (): string => {
      return `/web/recurring-job-groups/jobs`;
    },
    DELETAR: (groupId: string): string => {
      return `web/recurring-job-groups/${groupId}`;
    },
    ATUALIZAR: (groupId: string): string => {
      return `web/recurring-job-groups/${groupId}`;
    },
    LINK_JOB_ON_GROUP: (recurringJobGroupId: string): string => {
      return `web/recurring-job-groups/${recurringJobGroupId}/jobs`;
    },
    UNLINK_JOBS_ON_GROUPS: (recurringJobGroupId: string): string => {
      return `web/recurring-job-groups/${recurringJobGroupId}/jobs`;
    },
    RUN_JOBS: (recurringJobGroupId: string): string => {
      return `web/recurring-job-groups/${recurringJobGroupId}/trigger`;
    },
    CRIAR: (): string => {
      return `web/recurring-job-groups`;
    },
  },
};
export default URL;
